import type {PropsWithChildren} from 'react';
import {Helmet, HelmetProvider} from 'react-helmet-async';

type Props = PropsWithChildren<{
  readonly title: string;
  readonly companyName: string;
}>;

export function Head({title, companyName}: Props) {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{`${title} | ${companyName}のプレスリリース`}</title>
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      </Helmet>
    </HelmetProvider>
  );
}
